import { Service } from '../Service';

class Account extends Service {
    constructor(path) {
        super('/Identities', path); // initial prefix
    }
}

export { Account };